import EventTreeEdge from './EventTreeEdge';
import {mxConstants} from "mxgraph-js";

class EventTreeSuccessEdge extends EventTreeEdge {
  constructor(value = 'yes') {
    super(EventTreeSuccessEdge.getMyStyle);
    this.setValue(value);
  }

  static get getMyStyle() {
    const style = EventTreeEdge.getMyStyle();
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(112,193,136,0.51)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(71,161,78,0.71)';
    // enforces connection positions
    style[mxConstants.STYLE_EXIT_X] = 1;
    style[mxConstants.STYLE_ENTRY_Y] = 0.5;
    style[mxConstants.STYLE_ENTRY_X] = 0;
    style[mxConstants.STYLE_EXIT_Y] = 0.5;
    return style;
  }
}

export default EventTreeSuccessEdge;
